import VatiaCheckoutSizes from "./VatiaCheckoutSizes";
import {motion} from "framer-motion";
import {Col, Row} from "reactstrap";
import {FormattedMessage} from "react-intl";

export default function VatiaCheckoutStep0(props){
    return (<motion.div
        className="box"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
    >
        <h1 style={{fontSize:36, marginBottom:10}}><FormattedMessage id={ 'abo.new.title' } defaultMessage={ 'Das Dr. Brauwolf Abo' }/></h1>
        <p style={{fontWeight:300, color:"grey", fontSize:17, marginBottom:40, paddingLeft:20, paddingRight:20}}>
            <span style={{maxWidth:450, display:"inline-block"}}><FormattedMessage id={ 'abo.new.text' } defaultMessage={ 'Erhalte jeden Monat das aktuelle Craft Beer of the Month. Die Grösse ist jederzeit änderbar. Auch als Geschenk geeignet.'} /></span>
            {/*<br/>*/}
            {/*Die Grösse kann jederzeit angepasst werden.*/}
        </p>
        {/*<h1 style={{fontSize:22, marginBottom:10, marginTop: 10, display:"inline-block", color: "#000"}}>Wähle deine Abogrösse</h1>*/}
        {/*<p style={{fontWeight:300, color:"grey", fontSize:17, marginBottom:40}}>*/}
        {/*    Jederzeit änderbar*/}
        {/*</p>*/}
        <form onSubmit={e => e.preventDefault()} style={{marginTop: 0, marginBottom: 20}}>
            <VatiaCheckoutSizes sizeData={props.sizeData} selectedSize={props.selectedSize} handleSizeSelection={props.handleSizeSelection} cards={props.cards} handleNext={props.handleNext}/>
            {/*<br/><br/>*/}
            {/*<button style={{backgroundColor:"#f19800",border:0,borderRadius:4,color:"#fff",padding:6,marginTop:0, width: 150, height: 50}}*/}
            {/*        onClick={() => {handleNext()}}>*/}
            {/*    Weiter >*/}
            {/*</button>*/}
        </form>
        {/*<Row style={{paddingLeft:"10%", paddingRight:"10%", paddingTop:80}}>*/}
        {/*    <Col lg={12} style={{textAlign: "center", fontSize:14, lineHeight:0.7, marginTop:3, color: "rgba(45,45,45,.6)"}}>*/}
        {/*        powered by <a style={{textDecoration:"underline", color: "rgba(45,45,45,.6)"}} target={"_blank"} href={"https://vatia.io"}>vatia</a>*/}
        {/*    </Col>*/}
        {/*</Row>*/}
    </motion.div>)
}